import React from "react";
import {useLocation} from "react-use";
import {Link} from "gatsby";
import styled from "styled-components";
import routes from "../../routes";
import screenSizes from "../../utils/screenSizes";
import LanguageSwitcherDesktop from "../UI/LanguageSwitcher/desktop";
import {injectIntl} from "gatsby-plugin-intl";

import logo from "../../images/svg/champion-logo.svg";

const DesktopMenu = ({intl}) => {
  const location = useLocation();

  // Get the current language code
  const currentLanguageCode = intl?.locale;

  return (
    <Menu>
      <div>
        <div>
          <img src={logo} height={65}/>
        </div>

        <nav>
          <ul>
            {routes.map((route, idx) => {
              const isActive = (
                (idx === 0 && location?.pathname === '/')
                ||
                (idx && location?.pathname?.includes(route.href))
              )
              return (
                <li key={route.title}>
                  <Link
                    className={isActive ? 'active' : ''}
                    to={`/${currentLanguageCode}${route.href}`}
                  >
                    {intl.formatMessage({ id: `menu.${route?.slug}` })}
                  </Link>
                </li>
              )
            })}
          </ul>
        </nav>

        <LanguageSwitcherDesktop/>
      </div>
    </Menu>
  )
}

export default injectIntl(DesktopMenu)

const Menu = styled.header `
  position: absolute;
  z-index: 1;
  width: 100vw;
  
  >div {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    padding: 30px 80px;

    >div {
      flex: 1;
    }

    > nav {

      ul {
        display: flex;
        flex-direction: row;
        justify-content: center;
        list-style: none;
        gap: 55px;
        padding: 0;

        a {
          color: var(--color-white);
          font-size: 30px;
          font-weight: 300;

          &.active {
            color: var(--color-silver);
            font-weight: 500;
          }
        }
      }
    }

    @media (min-width: ${screenSizes.mobile}) and (max-width: ${screenSizes.tablet}) {
      padding: 30px;
      
      > nav ul a {
        font-size: 26px;
      }
    }
  }

  @media (max-width: 1000px) {
    display: none;
  }
`
